import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  LoadGroupCreationRightsFulfilledAction,
  LoadGroupCreationRightsPendingAction,
  LoadGroupCreationRightsRejectedAction,
} from '../../domains/groupCreationRights/actions.types';

import type { GroupCreationRights } from './types';

export type LoadGroupCreationRightsAction =
  | LoadGroupCreationRightsPendingAction
  | LoadGroupCreationRightsFulfilledAction
  | LoadGroupCreationRightsRejectedAction;

const initialState: GroupCreationRights = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<GroupCreationRights, LoadGroupCreationRightsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER.LOAD_GROUP_CREATION_RIGHTS_PENDING': {
      return setPending();
    }
    case 'USER.LOAD_GROUP_CREATION_RIGHTS_FULFILLED': {
      return setFulfilled(action.payload);
    }
    case 'USER.LOAD_GROUP_CREATION_RIGHTS_REJECTED': {
      return setRejected(action.payload.error);
    }
    default:
      return state;
  }
};

export default reducer;
